import React, { useRef, useState } from "react";
import styled from "@emotion/styled";
import { theme } from "@src/components/nessie-web";
import { Box, Flex } from "./Boxes";
import useClickOutside from "@src/utils/useClickOutside";

const DropdownMenu = ({ children }) => (
  <Box
    display="block"
    position="absolute"
    top="100%"
    right="0"
    minWidth="160px"
    padding="10px 0"
    margin="2px 0 0"
    backgroundColor={theme.colors.white}
    border="2px solid"
    borderColor={theme.colors.taro30}
    borderRadius="30px"
    as="ul"
    style={{
      listStyle: "none",
      boxShadow: `0 6px 0 ${theme.colors.taro30}77`,
    }}
    zIndex={1000}
    overflow="hidden"
  >
    {children}
  </Box>
);

const DropDownItem = styled("li")`
  cursor: pointer;
  & > * {
    fontweight: 600;
    fontsize: 18px;
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: ${theme.colors.taro90};
    white-space: nowrap;
  }

  & > *:hover {
    text-decoration: none;
    background-color: ${theme.colors.taro10};
    outline: 0;
  }
`;

const DropDown = ({ children, Trigger }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  useClickOutside(ref, () => setOpen(false));

  return (
    <Flex position="relative">
      <Trigger aria-expanded={open} onClick={() => setOpen(!open)} />
      {open && <DropdownMenu ref={ref}>{children}</DropdownMenu>}
    </Flex>
  );
};

export { DropDownItem, DropDown };
